module.exports = __webpack_public_path__ + "img/girlchik.bf3f9020.jpg";